import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'
import { AuthAnbieter, useAuth } from './lib/auth'
import Anmelden from './seiten/Anmelden'
import Rahmen from './rahmen/Rahmen'
import Uebersicht from './seiten/Uebersicht'
import Fotos from './seiten/Fotos'
import Bewertungen from './seiten/Bewertungen'
import Einreichungen from './seiten/Einreichungen'
import Meldungen from './seiten/Meldungen'
import Profilmeldungen from './seiten/Profilmeldungen'
import Ortsdurchsicht from './seiten/Ortsdurchsicht'
import Pruefstand from './seiten/kennzahlen/Pruefstand'
import Journal from './seiten/kennzahlen/Journal'
import Dubletten from './seiten/kennzahlen/Dubletten'
import Herkunft from './seiten/kennzahlen/Herkunft'
import Kanaele from './seiten/kennzahlen/Kanaele'
import './stil/app.css'

export default function App() {
  return (
    <AuthAnbieter>
      <BrowserRouter>
        <Tor />
      </BrowserRouter>
    </AuthAnbieter>
  )
}

/**
 * Der Browser zeigt nur, was das Backend erlaubt hat. Er entscheidet nie
 * selbst über den Zugang — jede Anfrage wird ohnehin serverseitig geprüft
 * (§5.2). Dieses Tor ist Höflichkeit, keine Sicherheit.
 */
function Tor() {
  const { zugang } = useAuth()

  switch (zugang.art) {
    case 'laedt':
    case 'pruefe':
      return <Mitte>{zugang.art === 'laedt' ? 'Einen Moment …' : 'Prüfe die Berechtigung …'}</Mitte>

    case 'abgemeldet':
      return <Anmelden />

    case 'verweigert':
      return <KeinZugang meldung={zugang.meldung} />

    case 'gestoert':
      return <Stoerung meldung={zugang.meldung} />

    case 'berechtigt':
      return (
        <Routes>
          <Route path="/" element={<Rahmen />}>
            <Route index element={<Uebersicht />} />
            <Route path="fotos" element={<Fotos />} />
            <Route path="bewertungen" element={<Bewertungen />} />
            <Route path="einreichungen" element={<Einreichungen />} />
            <Route path="meldungen" element={<Meldungen />} />
            <Route path="profilmeldungen" element={<Profilmeldungen />} />
            {/* Pflege: keine Warteschlange — hier wartet nichts, es ist ein
                Bestand, der nur schrumpft, weil jemand hinsieht. */}
            <Route path="ortsdurchsicht" element={<Ortsdurchsicht />} />
            {/* §11: die Auswertungen — reine Leseansichten. */}
            {/* `/kennzahlen` landet auf den Kanälen: Der Auftrag vom
                22.09.2026 nennt diese Adresse, und die übrigen sechs sind
                über die Seitenleiste ohnehin eine Zeile tiefer erreichbar. */}
            <Route path="kennzahlen" element={<Navigate to="/kennzahlen/kanaele" replace />} />
            <Route path="kennzahlen/kanaele" element={<Kanaele />} />
            <Route path="kennzahlen/pruefstand" element={<Pruefstand />} />
            <Route path="kennzahlen/journal" element={<Journal />} />
            <Route path="kennzahlen/dubletten" element={<Dubletten />} />
            <Route path="kennzahlen/herkunft" element={<Herkunft />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        </Routes>
      )
  }
}

function Mitte({ children }: { children: React.ReactNode }) {
  return (
    <main className="mitte">
      <p className="gedaempft">{children}</p>
    </main>
  )
}

function KeinZugang({ meldung }: { meldung: string }) {
  const { abmelden, zugang } = useAuth()
  const email = 'nutzer' in zugang ? zugang.nutzer.email : null

  return (
    <main className="mitte">
      <div className="karte mitte-karte">
        <h2>Kein Zugang</h2>
        <p className="gedaempft">
          Die Anmeldung hat funktioniert{email ? ` (${email})` : ''}, aber dieses
          Konto darf hier nicht moderieren.
        </p>
        <p className="leise">{meldung}</p>
        <button className="knopf knopf-still" type="button" onClick={() => void abmelden()}>
          Abmelden
        </button>
      </div>
    </main>
  )
}

function Stoerung({ meldung }: { meldung: string }) {
  const { abmelden, erneutPruefen } = useAuth()
  return (
    <main className="mitte">
      <div className="karte mitte-karte">
        <h2>Gerade nicht prüfbar</h2>
        <p className="gedaempft">
          Die Berechtigung ließ sich nicht feststellen. Ohne Prüfung gibt es
          keinen Zugang — das ist Absicht.
        </p>
        <p className="leise">{meldung}</p>
        <div className="knopf-reihe">
          <button className="knopf knopf-haupt" type="button" onClick={erneutPruefen}>
            Erneut versuchen
          </button>
          <button className="knopf knopf-still" type="button" onClick={() => void abmelden()}>
            Abmelden
          </button>
        </div>
      </div>
    </main>
  )
}
